import { RedirectProps, RouteProps } from 'react-router';
import { combineReducers } from 'redux';
import { createReducer } from 'redux-act';
import { RouterState } from 'redux-first-history';

import { setRoutes } from '../actions/routing.actions';
import { routerReducer } from '../routes/reduxHistory';

declare global {
  type RouteGroup =
    /** Renders only when user is authorized (login) */
    | 'private'
    /** Renders only when user is not authorized */
    | 'public'
    /** Renders only when user is login */
    | 'first_time_setup'
    /** Renders when user is authorized and not authorized */
    | 'publicAndPrivate';

  interface RoutePropsExtended extends RouteProps {
    /** Unique name `{module}.{route}`
     * @example
     * "settings.general"
     * */
    name: string;
    group: RouteGroup;
    key?: string;
    permissions?: AppState['permissions'];
  }
  interface RedirectPropsExtended extends RedirectProps {
    /** Unique name `{module}.{route}`
     * @example
     * "settings.general"
     * */
    name: string;
    group: RouteGroup;
    key?: string;
  }
}

/**
 * FOR SOME FREAKING REASON TESTS THAT RELAY ON createStore FAILS COZ OF 'defaultRoutingRoutesState' BUT WORKS IN RUNTIME!!!
 * @example
 * import { defaultRoutingRoutesState } from '../routes/index.routes';
 * // in helpers/store.ts import rootReducer will be undefined!!!
 *  */

const defaultRoutesState: (RoutePropsExtended | RedirectPropsExtended)[] =
  process.env.NODE_ENV === 'test'
    ? ([] as (RoutePropsExtended | RedirectPropsExtended)[])
    : require('../routes/index.routes').defaultRoutingRoutesState;

const routesReducer = createReducer({}, defaultRoutesState);

routesReducer.on(setRoutes, (state, routes) => routes);

const routingReducer = combineReducers<{
  router: RouterState;
  routes: typeof defaultRoutesState;
}>({
  router: routerReducer,
  routes: routesReducer,
});

export default routingReducer;
